import Vue from 'vue'
import ApiService from '@/common/api.service'

export const state = {
  /*
   * poiSelectionSets is a "grouping" of multiple POI's that are
   * selected. For example, one might wish to have a "global" set of
   * selected POI's that is persistent across all screens or one
   * might want to create a set of selected POI's for a particular
   * individual/group of widgets.
   */
  poiSelectionSets: {},
  queryByClient: null
}

export const getters = {
  /**
   * Returns the full state object
   *
   * @param state Object
   *
   * @return Object
   */
  get (state) {
    return state
  },

  /**
   * Returns the sets of selected POI's.
   *
   * @param state Object
   *
   * @return Object
   */
  poiSelectionSets (state) {
    return state.poiSelectionSets
  },

  /**
   * Returns either a client object or null depending on whether
   * queries should be made by client.
   *
   * @param state
   *
   * @return {Object|null}
   */
  getClient (state) {
    return state.queryByClient
  }
}

export const actions = {
  /**
   * Query/find one or more POI's.
   *
   * @param context Object
   * @param params  Array of query key's and values
   *
   * @return Promise
   */
  query (context, params) {
    const queryByClient = context.getters['getClient']
    if (queryByClient !== null) {
      return ApiService
        .get(`client/poi/by-client/${queryByClient.id}`, params)
        .then((response) => {
          return response
        })
    } else {
      return new Promise((resolve) => {
        resolve()
      })
    }
  }
}

export const mutations = {
  /**
   * Add a map or array of object POI's that have been selected within
   * the specified set.
   *
   * @param state    Object
   * @param set      String
   * @param vehicles Array|Map
   */
  addSelectedPois (state, { set, pois }) {
    if (!state.poiSelectionSets.hasOwnProperty(set)) {
      Vue.set(state.poiSelectionSets, set, {})
    }

    pois.forEach(poi => {
      Vue.set(state.poiSelectionSets[set], poi.id, poi)
    })
  },

  /**
   * Removes an array of POI's from the set's list of selected POI's.
   * The array must consist of the id's of the POI's that are no
   * longer selected.
   *
   * @param state    Object
   * @param set      String
   * @param pois     Array
   */
  removeSelectedPois (state, { set, pois }) {
    if (state.poiSelectionSets.hasOwnProperty(set)) {
      pois.forEach(poi => {
        Vue.delete(state.poiSelectionSets[set], poi.id)
      })
    }
  },

  /**
   * Clears all selected POI's.
   *
   * @param state  Object
   */
  clearAllSelectedPois (state) {
    Vue.set(state, 'poiSelectionSets', {})
  },

  /**
   * Clears all selected POI's within a specified set.
   *
   * @param state  Object
   * @param set      String
   */
  clearSelectedPois (state, set) {
    if (state.poiSelectionSets.hasOwnProperty(set)) {
      Vue.set(state.poiSelectionSets, set, {})
    }
  },

  /**
   * Purge the module's state.
   *
   * @param state Object
   */
  purge (state) {
    state.poiSelectionSets = {}
    state.queryByClient = null
  },

  /**
   * Sets the client for which the POI's should be queried.
   *
   * @param state
   * @param client Object|null
   */
  setClient (state, client) {
    state.queryByClient = client
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/poi/findClientPoiWidgetModule.js